type MessageBubbleProps = {
  role: string;
  text: string;
  agentAvatar: string;
  avatar: string | null
};

export function MessageBubble({ role, text, agentAvatar, avatar }: MessageBubbleProps) {
  return (
    <div className={`vcw-row ${role}`}>
      {role === "assistant" || role === "agent" ? (
        <div className="vcw-msg-avatar" aria-hidden="true">
          <img src={role === "agent" && avatar ? avatar : agentAvatar} alt="" className="vcw-avatar-img" />
        </div>
      ) : null}
      <MessageContent role={role} text={text} />
    </div>
  );
}

type MessageContentProps = {
  role: string;
  text: string;
};

function MessageContent({ role, text }: MessageContentProps) {
  return (
    <div className={`vcw-bubble ${role}`}>
      <div className="vcw-msg-text">{text}</div>
    </div>
  );
}
